export default "__VITE_ASSET__BSrOy6mK__"